import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export const uploadNewStudentIdCardUrl = `${BASE_API_URL}/xshy/uploadIdCard`
export const uploadNewStudentIdCard = (...args) => {
  return post(uploadNewStudentIdCardUrl, ...args)
}

export const recognitionIdCardUrl = `${BASE_API_URL}/xshy/recognitionIdCard`
export const recognitionIdCard = (...args) => {
  return post(recognitionIdCardUrl, ...args)
}

export const recognitionFaceIdUrl = `${BASE_API_URL}/xshy/recognitionFaceId`
export const recognitionFaceId = (...args) => {
  return post(recognitionFaceIdUrl, ...args)
}

export const queryCheckConfigUrl = `${BASE_API_URL}/xshy/queryRecognitionConfig`
export const queryCheckConfig = (...args) => {
  return post(queryCheckConfigUrl, ...args)
}
